import { useDispatch, useSelector } from "react-redux";
import {
  updateRoomDetails,
  updateMealPlan,
  updateSelectedRoomNumberForModify,
  updateRoomPriceStructure,
  updateSelectedCheckInDateTime,
  updateSelectedCheckOutDateTime,
  updateRoomAvailabiltyArray,
  updateFilteredRoomAvailabiltyArray,
  updateNightsCount,
  updatetaxIncludedInPriceLocalState,
  updateAdults,
  updateChildren,
  updateDetailedPriceBreakup,
  updateRoomAvailabiltyApiError,
  updateDiscountInfo,
  updateAreDatesUpdated,
} from "../../reducer/bookingReducer";
import { 
  validatePreviousRoomsForNewDates,
  showUnavailableRoomNotifications,
  showAllRoomsPreservedNotification
} from "../../utils/roomValidationHelper";
import { useEffect } from "react";
import {
  createRoomPriceStructure,
  CURRENCY_FORMAT,
  GET_ISO_FORMAT,
  GET_TODAY_DATE_WITH_ISO_FORMAT,
  GET_TOMORROW_DATE,
} from "../../utils/helper";
import { getRoomsAvailability } from "../../services/walkin";
import { calculateNumberOfNights } from "../../utils/bookingDetailsHelper";
import useGetMealPlanRate from "./useGetPlanRate";
import {
  generateDetailedPriceBreakupForEditBookings
} from "../../utils/bookingHelper";
import useAllBookingFunction from './useAllBookingFunction'

// Flow will be
// 1. First we will fetch availabilty for given date
// 2. Then we will build Room PriceSructure
// 3. Then oonce this roomPriceStructure is build we will fetch Occupance plan rate
/// 4. After this We will build roomAvavilabaility array to show on Screen

const useRoomDrawerLogic = (setLoading, mealPlanChanged) => {
  const dispatch = useDispatch();

  const { hotelDetails, occupancyPlanRate } = useSelector(
    (store) => store.login
  );

  const {
    bookingDetails,
    selectedCheckInDateTime,
    selectedCheckOutDateTime,
    changeDateBoolean,
    areDatesUpdated,
    displayRoomDrawer,
    invoiceDetails,
    roomList,
    roomPriceStructure,
    mealPlan,
    detailedPriceBreakup,
    selectedRoomWTypeAndNum,
    roomAvailabiltyArray,
    filteredRoomAvailabilityArray,
    nightsCount,
    adults,
    children,
  } = useSelector((store) => store.booking);

  const rooms = hotelDetails?.roomTypes ? hotelDetails?.roomTypes : [];
  const { response } = useSelector((store) => store.rooms);

  const { getPlanRate } = useGetMealPlanRate(roomPriceStructure, mealPlan);

  const {
    calculateDefaultOccupancy
  } = useAllBookingFunction();


  useEffect(() => {
    if (changeDateBoolean) {
      if (areDatesUpdated) {
        fetchRoomAvailabilityData(false);
      }
    } else if (displayRoomDrawer) {
      fetchRoomAvailabilityData(true);
    }
  }, [displayRoomDrawer, changeDateBoolean, areDatesUpdated]);

  useEffect(() => {
    if (displayRoomDrawer) getPlanRate(rooms, roomPriceStructure, mealPlan);
  }, [roomPriceStructure]);

  useEffect(() => {
    if (displayRoomDrawer) storeData();
  }, [occupancyPlanRate, displayRoomDrawer, selectedRoomWTypeAndNum]);
/*
  useEffect(() => {
    if (Array.isArray(detailedPriceBreakup) && detailedPriceBreakup?.length) {
      modifyDetailedPriceBrekup(
        detailedPriceBreakup,
        rooms,
        occupancyPlanRate,
        mealPlan,
        dispatch,
        updateDetailedPriceBreakup
      );
    }
  }, [occupancyPlanRate]);
*/

  const fetchRoomAvailabilityData = async (isInitial) => {
    setLoading(true);

    const payload = {
      bookingId: bookingDetails?.id,
      startDate: Boolean(
        isInitial ? bookingDetails?.checkIn : selectedCheckInDateTime
      )
        ? GET_ISO_FORMAT(
            isInitial ? bookingDetails?.checkIn : selectedCheckInDateTime
          )
        : GET_TODAY_DATE_WITH_ISO_FORMAT(),
      endDate: Boolean(
        isInitial ? bookingDetails?.checkOut : selectedCheckOutDateTime
      )
        ? GET_ISO_FORMAT(
            isInitial ? bookingDetails?.checkOut : selectedCheckOutDateTime
          )
        : GET_ISO_FORMAT(GET_TOMORROW_DATE()),
      hotelId: hotelDetails?.id,
    };

    let availResponse = await getRoomsAvailability(
      payload,
      "bookings/availability"
    );

    if (Boolean(availResponse?.status === 200)) {
      dispatch(updateRoomDetails({ response: availResponse?.data }));
      dispatch(updateRoomAvailabiltyApiError(null));
    } else {
      dispatch(updateDetailedPriceBreakup([]));
      dispatch(updateRoomPriceStructure([]));
      setLoading(false);
      dispatch(
        updateRoomAvailabiltyApiError(availResponse?.response?.data?.message)
      );
      return;
    }

    const namesToFilter = Array.isArray(rooms)
      ? rooms?.map((item) => item.name)
      : [];
    const updatedData = Array.isArray(availResponse?.data)
      ? availResponse?.data?.filter((item) => namesToFilter?.includes(item._id))
      : [];

    // Processing room price structure
    let localRoomPriceStructure = updatedData?.map((obj) => {
      const roomDetails = rooms?.find((room) => room?.name === obj?._id);

      const currentPriceBreakupObj = isInitial
        ? invoiceDetails
            ?.find((Obj) => Obj?.invoiceType === "roomBill")
            ?.priceBreakup?.find((Obj) => Obj?.type === obj?._id)
        : null;

      let defaultOccupancy = calculateDefaultOccupancy({roomDetails});

      let rate = Boolean(isInitial)
        ? Boolean(currentPriceBreakupObj)
          ? currentPriceBreakupObj?.baseRate ?? currentPriceBreakupObj?.rate
          : occupancyPlanRate?.[roomDetails?._id]?.[bookingDetails?.mealPlan]?.[
              defaultOccupancy
            ]
        : roomDetails?.rate;
      const roomStructureObject = {
        name: obj?._id,
        rate: +CURRENCY_FORMAT(rate) || 0
      };

      return roomStructureObject;
    });

    if (isInitial) {
      // Handle initial API-specific logic
      let selectedRoomTypeWithRoom = {};
      
    let roomInvoice = invoiceDetails?.find(
      (Obj) => Obj.invoiceType === "roomBill"
    );
    let roomsInThisBooking = bookingDetails?.rooms;
    let detailedRoomInthisBooking = response?.filter((Obj) =>
      roomsInThisBooking?.includes(Obj?.id)
    );
      const night = calculateNumberOfNights(
          bookingDetails?.checkIn,
          bookingDetails?.checkOut,
          hotelDetails
      ) ;
      let localDetailedPriceBrekup = roomInvoice?.detailedPriceBreakup && roomInvoice?.detailedPriceBreakup.length > 0 
      ? roomInvoice?.detailedPriceBreakup : 
      generateDetailedPriceBreakupForEditBookings({
        detailedRoomInthisBooking,
        roomTypes: rooms,
        noOfNights: night,
        priceBreakup: roomInvoice?.priceBreakup,
        complimentaryRoomIds: bookingDetails?.markedComplementaryRoomIdArrayInBooking,
      });
      const baseRoomPriceStructure = createRoomPriceStructure(rooms);
      localRoomPriceStructure?.forEach(rps=>{
        const detailedPriceBreakupEntry = localDetailedPriceBrekup?.find(ldpbe=>ldpbe?.name === rps.name);
        let extraGuestRate = detailedPriceBreakupEntry?.extraAdultRate || 0;
        let singleGuestPriceReduction = detailedPriceBreakupEntry?.singleGuestReductionRate || 0;
        const roomType = rooms?.find(roomTypeObj=> roomTypeObj?.name === rps?.name);
        const baseRoomPriceStructureEntry = baseRoomPriceStructure?.find(brps=> brps?.name === rps?.name)
        if(!extraGuestRate && roomType && baseRoomPriceStructureEntry?.extraGuestRate) {
          extraGuestRate = baseRoomPriceStructureEntry?.extraGuestRate;
        }
        if(!singleGuestPriceReduction && baseRoomPriceStructureEntry?.singleGuestPriceReduction) {
          singleGuestPriceReduction = baseRoomPriceStructureEntry?.singleGuestPriceReduction;
        }
        rps['extraGuestRate'] = extraGuestRate;
        rps['extraAdultRate'] = extraGuestRate;
        rps['extraChildRate'] = detailedPriceBreakupEntry?.extraChildRate || baseRoomPriceStructureEntry?.extraChildRate || 0;
        rps['singleGuestPriceReduction'] = singleGuestPriceReduction;
      })
      response?.forEach((item) => {
        let rooms = bookingDetails?.rooms;
        rooms?.map((room) => {
          const roomPriceBreakupEntry = localDetailedPriceBrekup?.find(dpb=> dpb.id === room);
          if (item.id === room) {
            const roomData = {
              id: item.id, 
              name:item.name, 
              roomTypeId: item.roomTypeId,
              roomTypeName: item.type,
              rate: roomPriceBreakupEntry?.baseRate,
              occupancy: roomPriceBreakupEntry?.occupancy,
              taxIds: roomPriceBreakupEntry?.taxIds,
              adults: roomPriceBreakupEntry?.adults || roomPriceBreakupEntry?.occupancy ,
              children: roomPriceBreakupEntry?.children,
            }
            selectedRoomTypeWithRoom[item.type] =
              selectedRoomTypeWithRoom[item.type] !== undefined
                ? [...selectedRoomTypeWithRoom[item.type], roomData]
                : [roomData];
          }
        });
      });

      dispatch(updateSelectedCheckInDateTime(bookingDetails?.checkIn));
      dispatch(updateSelectedCheckOutDateTime(bookingDetails?.checkOut));
      dispatch(updateMealPlan(bookingDetails?.mealPlan ?? "EP"));
      dispatch(updateAdults(bookingDetails?.adults ?? 1));
      dispatch(updateSelectedRoomNumberForModify(selectedRoomTypeWithRoom));
      dispatch(updateNightsCount(night));
      dispatch(updateDiscountInfo(roomInvoice?.discountInfo))
      dispatch(updateRoomPriceStructure(localRoomPriceStructure));

    } else {
      // Handle date change API-specific logic - PRESERVE ROOMS WHERE POSSIBLE
      
      // Capture previously selected rooms before any modifications
      // Use current Redux state with proper null checking
      const previousSelectedRooms = selectedRoomWTypeAndNum ? 
        JSON.parse(JSON.stringify(selectedRoomWTypeAndNum)) : {};
      
      try {
        // Validate rooms against new availability data
        // Rename variable to avoid confusion with other updatedData variables
        const newAvailabilityData = updatedData;
        const { availableRooms, unavailableRooms } = validatePreviousRoomsForNewDates(
          previousSelectedRooms,
          newAvailabilityData,
          rooms
        );
        
        // Update selected rooms with only available ones
        dispatch(updateSelectedRoomNumberForModify(availableRooms));
        
        // Show notifications about room availability changes
        if (unavailableRooms.length > 0) {
          showUnavailableRoomNotifications(unavailableRooms, availableRooms);
        } else if (Object.keys(availableRooms).length > 0) {
          showAllRoomsPreservedNotification(availableRooms);
        }
        
        // Handle guest counts and meal plan based on preserved rooms
        const preservedRoomCount = Object.keys(availableRooms).reduce((sum, type) => sum + availableRooms[type].length, 0);
        
        if (preservedRoomCount === 0) {
          // No rooms preserved - reset to defaults
          dispatch(updateAdults(1));
          dispatch(updateMealPlan("EP"));
        } else {
          // Rooms preserved - validate and adjust guest counts if needed
          const currentAdults = adults || 1;
          const currentChildren = children || 0;
          const totalGuests = currentAdults + currentChildren;
          
          // Ensure guest count doesn't exceed room capacity
          // Basic validation: assume max 4 guests per room (configurable per hotel)
          const maxGuestsAllowed = preservedRoomCount * 4;
          
          if (totalGuests > maxGuestsAllowed) {
            // Adjust guest count to fit preserved rooms
            const adjustedAdults = Math.min(currentAdults, maxGuestsAllowed);
            dispatch(updateAdults(adjustedAdults));
            
            const remainingCapacity = maxGuestsAllowed - adjustedAdults;
            const adjustedChildren = Math.min(currentChildren, remainingCapacity);
            dispatch(updateChildren(adjustedChildren));
          }
          // Keep existing meal plan when rooms are preserved
        }
        
      } catch (error) {
        // If room validation fails, fall back to original behavior (clear rooms)
        console.error('Room preservation failed:', error);
        dispatch(updateSelectedRoomNumberForModify({}));
        dispatch(updateAdults(1));
        dispatch(updateMealPlan("EP"));
        
        // Show error notification
        if (typeof showUnavailableRoomNotifications === 'function') {
          try {
            showUnavailableRoomNotifications([], {});
          } catch (notificationError) {
            console.error('Failed to show notification:', notificationError);
          }
        }
      }
    }
    dispatch(updateAreDatesUpdated(false));

    // dispatch(updateDetailedPriceBreakup([]));
    setLoading(false);
  };

  const storeData = async () => {

    const namesToFilter = Array.isArray(rooms)
      ? rooms?.map((item) => item.name)
      : [];

    const updatedData = Array.isArray(roomList)
      ? roomList?.filter((item) => namesToFilter?.includes(item._id))
      : [];

    let roomsInThisBooking = [];
    if(selectedRoomWTypeAndNum && Object.keys(selectedRoomWTypeAndNum).length > 0) {
       Object.keys(selectedRoomWTypeAndNum).forEach((roomType) =>{
        for(const roomData of selectedRoomWTypeAndNum[roomType]){
           roomsInThisBooking.push(roomData.id);
        }
      }
      );
    }
    let detailedRoomInthisBooking = response?.filter((Obj) =>
      roomsInThisBooking?.includes(Obj?.id)
    );

    const localroomAvailability = updatedData?.map((avail) => {
      const roomDetails = rooms?.find((room) => room?.name === avail?._id);

      let currentRoomPriceStr = roomPriceStructure?.find(
        (Obj) => Obj?.name === avail?._id
      );

      let defaultOccupancy = Boolean(roomDetails?.defaultOccupancy)
        ? roomDetails?.defaultOccupancy
        : 2;

      let maxGuestAllowed = Boolean(roomDetails?.guestsAllowed)
        ? roomDetails?.guestsAllowed
        : 3;

      let rate = mealPlanChanged
        ? occupancyPlanRate?.[roomDetails?._id]?.[mealPlan]?.[defaultOccupancy]
        : currentRoomPriceStr?.rate;

      let isRoomTypePresent =
        Object?.keys(selectedRoomWTypeAndNum)?.find((Obj) => Obj === avail?._id)
          ?.length ||
        detailedRoomInthisBooking?.find((Obj) => Obj?.type === avail?._id);

      let coountButtonVisible = Boolean(isRoomTypePresent);

      const availObj = {
        name: avail?._id,
        availability: avail?.availability,
        rooms: avail?.rooms,
        rate: rate,
        breakfastPrice: roomDetails
          ? Number(roomDetails?.breakfastPrice)
          : null,
        mealPrice: roomDetails ? Number(roomDetails?.mealPrice) : null,
        defaultOccupancy: defaultOccupancy,
        maxGuestAllowed: maxGuestAllowed,
        taxIds: Array.isArray(roomDetails?.taxIds) ? roomDetails?.taxIds : [],
        countButtonVisible: coountButtonVisible,
        extraGuestPricePerPerson: roomDetails?.extraGuestPricePerPerson,
        singleOccupancyPriceReduction: roomDetails?.singleOccupancyPriceReduction,
        meanPlanBasedPricingEnabled: roomDetails?.meanPlanBasedPricingEnabled,
        mealPlanPricingDetailsMap: roomDetails?.mealPlanPricingDetailsMap
      };
      return availObj;
    });
    let isOTABooking = Boolean(bookingDetails?.cmId);

    let roomInvoice = invoiceDetails?.find(
      (Obj) => Obj.invoiceType === "roomBill"
    );

    const taxInclusion = Array.isArray(invoiceDetails)
      ? roomInvoice?.taxIncludedInPrice
      : false;

    
    dispatch(updatetaxIncludedInPriceLocalState(taxInclusion));
    dispatch(updateRoomAvailabiltyArray(localroomAvailability));
    dispatch(updateFilteredRoomAvailabiltyArray(localroomAvailability));
  };
};

export default useRoomDrawerLogic;
